module.exports = __webpack_public_path__ + "media/images/leads-66f14ba4cf1d525a50ce1a3ff7cb1a7d.png";